/**
 * FinancePage - Wrapper для кэширования данных Финансов через React Query
 * НЕ изменяет логику Finance.jsx, только кэширует API-запросы
 */
import { useQuery } from "@tanstack/react-query";
import api from "@/utils/api";
import Finance from "@/pages/Finance";

// Функции для загрузки данных
const fetchFinanceData = async () => {
  const response = await api.get("/fast/finance", {
    params: { limit: 10000, offset: 0 }
  });
  return response.data;
};

const fetchStocksData = async () => {
  const response = await api.get("/fast/stocks");
  return response.data;
};

const fetchSettings = async () => {
  const response = await api.get("/settings");
  return response.data;
};

const fetchSyncStatus = async () => {
  const response = await api.get("/sync/status");
  return response.data;
};

export default function FinancePage() {
  // Кэшированные запросы
  const financeQuery = useQuery({
    queryKey: ["finance"],
    queryFn: fetchFinanceData,
  });

  const stocksQuery = useQuery({
    queryKey: ["stocks"],
    queryFn: fetchStocksData,
  });

  const settingsQuery = useQuery({
    queryKey: ["settings"],
    queryFn: fetchSettings,
  });

  const syncStatusQuery = useQuery({
    queryKey: ["syncStatus"],
    queryFn: fetchSyncStatus,
  });

  // Собираем данные для передачи в компонент
  const cachedData = {
    products: financeQuery.data?.products || [],
    transactions_by_sku: financeQuery.data?.transactions_by_sku || {},
    synced: financeQuery.data?.synced ?? false,
    stocks: stocksQuery.data?.items || [],
    settings: settingsQuery.data || { low_stock_threshold: 10 },
    syncStatus: syncStatusQuery.data || null,
  };

  const isLoading = financeQuery.isLoading || stocksQuery.isLoading;

  // Функция обновления кэша
  const refetchAll = async () => {
    await Promise.all([
      financeQuery.refetch(),
      stocksQuery.refetch(),
      settingsQuery.refetch(),
      syncStatusQuery.refetch(),
    ]);
  };

  // Передаём данные через props
  return (
    <Finance
      cachedData={cachedData}
      cachedLoading={isLoading}
      onRefetch={refetchAll}
    />
  );
}
